import { Requested } from './Types';

export type AlertStatus = 'forreview' | 'open' | 'investig' | 'watch' | 'critical' | 'explained' | 'closed'


export const ALERT_STATUS_TO_DISPLAY_NAME: {
    [T in AlertStatus]: string
} = {
    'forreview': 'For Review',
    'open': 'Open',
    'watch': 'Watch',
    'investig': 'Investigating',
    'critical': 'Critical',
    'explained': 'Explained',
    'closed': 'Closed',
};

export const ALERT_STATUS_DISPLAY_NAME_TO_STATUS: {
    [T in string]: AlertStatus
} = {
    'For Review': 'forreview',
    'Open': 'open',
    'Watch': 'watch',
    'Investigating': 'investig',
    'Critical': 'critical',
    'Explained': 'explained',
    'Closed': 'closed',
};

type DateString = string;
export interface IAlert {
    show: number | null;
    valid: number | null;
    id: number | null;
    description: string | null;
    description_long: string | null;
    ad_id: number | null;
    ad_alert_id: number | null;
    ad_created_timestamp: DateString | null;
    ref_date: DateString | null;
    ref_timestamp: DateString | null;
    ad_description: string | null;
    symbol: string | null;
    order_id: number | null;
    trade_id: number | null;
    private_order_id: string | null;
    private_trade_id: string | null;
    private_trade_report_id: string | null;
    private_client_id: string | null;
    order_value: number | null;
    outside_spread: boolean | null;
    ad_username: string | null;
    ad_groupid: string | null;
    pricechange: number | null;
    trader_id: string | null;
    generated_limit: number | null;
    currency: string | null;
    volume: number | null;
    trade_class: string | null;
    order_age: IInterval | null;
    daydiff: number | null;
    newstitle: string | null;
    newstimestamp: DateString | null;
    timediff: IInterval | null;
    security_type: string | null;
    ap_id: string | null;
    ap_alert_id: number | null;
    ap_description: string | null;
    ap_description_long: string | null;
    ac_alert_id: number | null;
    param_id: string | null;
    ac_groupid: string | null;
    ac_username: string | null;
    value: number | null;
    ac_created_timestamp: DateString | null;
    config_id: number | null;
    adu_alert_data_id: number | null;
    adu_groupid: string | null;
    adu_username: string | null;
    alert_comment: string | null;
    comment_timestamp: DateString | null;
    status: AlertStatus | null;
    review_id: number | null;
}

export type AlertTickData = IAlert & {
    tickdata_type: 'Alert',
    timestamp: string | null,
    attachments?: IAlertReviewAttachment[]
}

export interface IAlertConfig {
    id: number;
    description: string;
    description_long: string;
    private: boolean | null;
    shares: boolean | null;
    bonds: boolean | null;
    currency: string | null;
    alertConfigParameters: IAlertConfigParameter[];
}

export interface IAlertConfigParameter {
    id: string;
    alert_id: number;
    description: string;
    description_long: string;
    default_value: number | null;
    default_value_text: string | null;
    alertConfigParameterHistory: IAlertConfigParameterHistoryEntry[];
}

export interface IAlertConfigParameterHistoryEntry {
    config_id: number;
    alert_id: number;
    value: number | null;
    value_text: string | null;
    username: string;
    param_id: string;
    created_timestamp: DateString;
    groupid: string;
}

export interface IAlertConfigParameterChange {
    alertId: number,
    paramId: string,
    newValue: number | string | null
}

export interface IAlertReviewAttachment {
    alert_review_id: number;
    s3_key: string;
    filename: string;
    content_type: string;
    file_size_bytes: number;
    uploaded_timestamp: string;
    url?: string; // signed S3 download url
}

export interface IAlertDataUserInfo {
  alert_data_id: number;
  username: string;
  comment_timestamp: DateString;
  alert_comment: string;
  status: AlertStatus;
  groupid: string;
  review_id: number;
  attachments?: IAlertReviewAttachment[];
}

export interface IInterval {
    years?: number | null;
    months?: number | null;
    days?: number | null;
    hours?: number | null;
    minutes?: number | null;
    seconds?: number | null;
    milliseconds?: number | null;
  }

export type AlertReviewHistoryByAlertDataId = {
    [alertDataId: number]: Requested<IAlertDataUserInfo[]>
}

export interface IAlertHardLimitError {
    configParamId: string,
    errorMessage: string
}